// Admin Toast Hook - wrapper for NotificationContext for admin panel
import { useNotification } from '../context/NotificationContext';
import { getApiErrorMessage } from '../utils/apiErrorHandler';

export const useAdminToast = () => {
  const { toast: baseToast } = useNotification();

  const toast = {
    success: (message, title = 'Успешно') => {
      baseToast.success(title, message);
    },
    
    error: (message, title = 'Ошибка') => {
      baseToast.error(title, message);
    },
    
    warning: (message, title = 'Внимание') => {
      baseToast.warning(title, message);
    },
    
    info: (message, title = 'Информация') => {
      baseToast.info(title, message);
    },

    // Specialized admin notifications
    saved: (item = 'Данные') => {
      baseToast.success('Сохранено', `${item} успешно сохранены`);
    },

    deleted: (item = 'Запись') => {
      baseToast.success('Удалено', `${item} успешно удалена`);
    },

    created: (item = 'Запись') => {
      baseToast.success('Создано', `${item} успешно создана`);
    },

    updated: (item = 'Данные') => {
      baseToast.success('Обновлено', `${item} успешно обновлены`);
    },

    // Error with API response handling
    apiError: (err, defaultMsg = 'Произошла ошибка') => {
      const message = getApiErrorMessage(err, defaultMsg);
      baseToast.error('Ошибка', message);
    },

    // Validation error
    validation: (message) => {
      baseToast.warning('Ошибка валидации', message);
    },

    // Action result
    actionResult: (successCount, totalCount, action = 'обработано') => {
      if (successCount === totalCount) {
        baseToast.success('Выполнено', `${action}: ${successCount} из ${totalCount}`);
      } else {
        baseToast.warning('Частичный успех', `${action}: ${successCount} из ${totalCount}`);
      }
    }
  };

  return { toast };
};

export default useAdminToast;
